module.exports = __webpack_public_path__ + "img/gmail-old-icon.be0af9cc.png";